export const breakpoints = [600, 960, 1280, 1920, 2400];
